export const DEFAULT_THEME_OPTIONS = [
  {
    id: 'default-classic-elegance',
    name: 'Classic Elegance',
    description: 'Timeless sophistication with ivory and gold accents',
    colors: {
      primary: '#5D7061',
      secondary: '#D4AF37',
      accent: '#E8D5B7',
      background: '#FAF9F6',
      text: '#2D3436',
      muted: '#6B7280',
    },
    decorations: {
      pattern: 'floral',
      icons: ['rose', 'leaf', 'heart'],
      border_style: 'elegant',
    },
    fonts: {
      heading: 'League Spartan',
      body: 'Manrope',
      accent: 'Great Vibes',
    },
    preview_gradient: 'linear-gradient(135deg, #5D7061, #D4AF37)',
    mood: 'elegant',
  },
  {
    id: 'default-royal-romance',
    name: 'Royal Romance',
    description: 'Regal purple tones with golden highlights',
    colors: {
      primary: '#6B4E71',
      secondary: '#C9A227',
      accent: '#E8D5E0',
      background: '#FBF8FC',
      text: '#2D2433',
      muted: '#7B6B80',
    },
    decorations: {
      pattern: 'paisley',
      icons: ['peacock', 'lotus', 'crown'],
      border_style: 'traditional',
    },
    fonts: {
      heading: 'Cormorant Garamond',
      body: 'Lato',
      accent: 'Tangerine',
    },
    preview_gradient: 'linear-gradient(135deg, #6B4E71, #C9A227)',
    mood: 'royal',
  },
  {
    id: 'default-garden-bliss',
    name: 'Garden Bliss',
    description: 'Fresh botanical greens with blush pink touches',
    colors: {
      primary: '#4A7C59',
      secondary: '#E8B4B8',
      accent: '#F5E6D3',
      background: '#FAFEF7',
      text: '#2D3B2D',
      muted: '#6B7B6B',
    },
    decorations: {
      pattern: 'botanical',
      icons: ['leaf', 'flower', 'butterfly'],
      border_style: 'romantic',
    },
    fonts: {
      heading: 'Libre Baskerville',
      body: 'Source Sans Pro',
      accent: 'Sacramento',
    },
    preview_gradient: 'linear-gradient(135deg, #4A7C59, #E8B4B8)',
    mood: 'romantic',
  },
  {
    id: 'default-modern-minimalist',
    name: 'Modern Minimalist',
    description: 'Clean lines with monochromatic sophistication',
    colors: {
      primary: '#2C3E50',
      secondary: '#BDC3C7',
      accent: '#ECF0F1',
      background: '#FFFFFF',
      text: '#1A1A2E',
      muted: '#7F8C8D',
    },
    decorations: {
      pattern: 'geometric',
      icons: ['diamond', 'line', 'circle'],
      border_style: 'modern',
    },
    fonts: {
      heading: 'Montserrat',
      body: 'Open Sans',
      accent: 'Allura',
    },
    preview_gradient: 'linear-gradient(135deg, #2C3E50, #BDC3C7)',
    mood: 'modern',
  },
  {
    id: 'default-sunset-celebration',
    name: 'Sunset Celebration',
    description: 'Warm oranges and coral with festive energy',
    colors: {
      primary: '#E07A5F',
      secondary: '#F4A261',
      accent: '#F9DCC4',
      background: '#FFF8F0',
      text: '#3D2C29',
      muted: '#8B7355',
    },
    decorations: {
      pattern: 'mandala',
      icons: ['sun', 'marigold', 'diya'],
      border_style: 'festive',
    },
    fonts: {
      heading: 'Rozha One',
      body: 'Mukta',
      accent: 'Pacifico',
    },
    preview_gradient: 'linear-gradient(135deg, #E07A5F, #F4A261)',
    mood: 'festive',
  },
];

export const DEFAULT_BACKGROUND_OPTIONS = [
  {
    id: 'ivory-mandala-corners',
    name: 'Sage Lace',
    url: '/assets/theme-backgrounds/ivory-mandala-corners.jpg',
  },
  {
    id: 'golden-lotus-corner',
    name: 'Pastel Mandala',
    url: '/assets/theme-backgrounds/golden-lotus-corner.jpg',
  },
  {
    id: 'golden-mandala-frame',
    name: 'Golden Aqua',
    url: '/assets/theme-backgrounds/golden-mandala-frame.jpg',
  },
];
